function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Dialog, DialogTitle, DialogActions, Typography } from "@material-ui/core";
import { useTrackerContext } from "@dpdgroupuk/react-event-tracker";
import { TrackableDialog } from "./Provider";
import Button from "../Button";
const useStyles = makeStyles(({
  zIndex,
  palette,
  typography,
  breakpoints
}) => ({
  dialog: {
    width: typography.pxToRem(433),
    backgroundColor: palette.background.modal,
    borderRadius: typography.pxToRem(6.4),
    opacity: 1
  },
  dialogTitle: {
    paddingTop: typography.pxToRem(50),
    paddingBottom: typography.pxToRem(43),
    color: palette.text.primary,
    textAlign: "center"
  },
  dialogTitleText: {
    fontSize: typography.pxToRem(18),
    letterSpacing: typography.pxToRem(0.44),
    whiteSpace: "pre",
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14)
    }
  },
  dialogActions: {
    paddingBottom: typography.pxToRem(25),
    justifyContent: "center",
    [breakpoints.down("xs")]: {
      padding: typography.pxToRem(20),
      paddingTop: 0
    }
  },
  dialogActionsSpacing: {
    "& > :not(:first-child)": {
      marginLeft: 50,
      [breakpoints.down("xs")]: {
        marginLeft: 20
      }
    }
  },
  button: {
    width: typography.pxToRem(115),
    height: typography.pxToRem(36)
  },
  confirmButton: {
    background: "#dc0032",
    "&:hover": {
      background: "#9a0023"
    }
  },
  rejectButton: {
    background: "#71c4ea",
    "&:hover": {
      background: "#4e98ba"
    }
  },
  buttonLabel: {
    fontSize: typography.pxToRem(12.6),
    letterSpacing: typography.pxToRem(0.45)
  }
}));

const ConfirmationDialog = ({
  onClose,
  title,
  onConfirm,
  confirmLabel = "YES",
  rejectLabel = "NO",
  analytics,
  ...props
}) => {
  const styles = useStyles();
  const tracker = useTrackerContext();
  const onConfirmClick = React.useCallback(() => {
    if (analytics) {
      analytics.confirm && tracker.logEvent(analytics.confirm);
      analytics.YES && tracker.logEvent(analytics.YES);
    }

    onClose();
    onConfirm();
  }, [onClose, onConfirm, analytics, tracker]);
  const onCloseClick = React.useCallback(() => {
    if (analytics && analytics.NO) {
      tracker.logEvent(analytics.NO);
    }

    onClose();
  }, [onClose, analytics, tracker]);
  return /*#__PURE__*/React.createElement(TrackableDialog, {
    analytics: analytics
  }, /*#__PURE__*/React.createElement(Dialog, _extends({
    maxWidth: "xs",
    fullWidth: true,
    classes: {
      paper: styles.dialog
    },
    onClose: onClose
  }, props), /*#__PURE__*/React.createElement(DialogTitle, {
    classes: {
      root: styles.dialogTitle
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.dialogTitleText
  }, title)), /*#__PURE__*/React.createElement(DialogActions, {
    classes: {
      root: styles.dialogActions,
      spacing: styles.dialogActionsSpacing
    }
  }, /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: clsx(styles.button, styles.rejectButton),
      label: styles.buttonLabel
    },
    onClick: onCloseClick
  }, rejectLabel), /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: clsx(styles.button, styles.confirmButton),
      label: styles.buttonLabel
    },
    onClick: onConfirmClick
  }, confirmLabel))));
};

export default ConfirmationDialog;